import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Map.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Secret from "../views/Secret.vue";

import firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Map",
    component: Home,
    // meta: { isThisShitAuthorized: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  },
  {
    path: "/secret",
    name: "Secret",
    component: Secret,
    meta: { isThisShitAuthorized: true }
  },
  {
    path: "/donate",
    name: "Donate",
    // route level code-splitting
    // this generates a separate chunk (donate.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "donate" */ "../views/Donate.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isThisShitAuthorized = to.matched.some(
    record => record.meta.isThisShitAuthorized
  );
  const isAuthenticated = firebase.auth().currentUser;
  if (isThisShitAuthorized && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;
